import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-invalid-dialog',
  templateUrl: './invalid-dialog.component.html',
  styleUrls: ['./invalid-dialog.component.css'],
})
export class InvalidDialogComponent implements OnInit {
  message: string;
  configId: string;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { message: string; config_id: string },
    private dialogRef: MatDialogRef<InvalidDialogComponent>,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.message = this.translate.instant(this.data?.message) || this.data?.message;
  }
  onConfirmClick(): void {
    this.dialogRef.close('true');
  }
}
